export default function isNumber(n) {
  return typeof n === 'number' && !isNaN(n)
}
